// AI-CONTEXT: See docs/features/livereport2-period-selector.md
//
// Normalizes a LiveReports2 report's Start/End into the ISO date range the
// widget tree filters on (via ReportPeriodContext). Handles live Firestore
// Timestamps and the serialized shapes the public viewer receives from
// getPublicLiveReport2 ({ _seconds } / { seconds }).
//
// Conversion uses LOCAL date parts, never toISOString(): PeriodSelector
// persists local start/end of day, and a UTC conversion would shift e.g.
// local midnight Jan 1 back to Dec 31.

/** @param {*} ts @returns {Date|null} */
const toDate = (ts) => {
    if (!ts) return null
    if (typeof ts.toDate === 'function') return ts.toDate()
    if (typeof ts._seconds === 'number') return new Date(ts._seconds * 1000)
    if (typeof ts.seconds === 'number') return new Date(ts.seconds * 1000)
    return null
}

/** @param {Date|null} d @returns {string|null} ISO 'YYYY-MM-DD' in local time */
const toLocalISODate = (d) => {
    if (!d || isNaN(d.getTime())) return null
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
}

/**
 * @param {{Start?: *, End?: *}|null|undefined} report - A LiveReports2 doc (live or serialized)
 * @returns {{start: string|null, end: string|null}|null} ISO date range, or null when no period is set
 */
const reportToPeriodRange = (report) => {
    const start = toLocalISODate(toDate(report?.Start))
    const end = toLocalISODate(toDate(report?.End))
    return (start || end) ? { start, end } : null
}

export default reportToPeriodRange
